<template>
  <template v-if="edit">
    <v-textarea v-model="newComment" autofocus label="Edit the comment" />
    <v-btn
      v-tooltip:bottom="'Cancel the edit'"
      color="warning"
      variant="outlined"
      @click="emit('cancel-edit')"
      >Cancel</v-btn
    >
    <v-btn
      v-tooltip:bottom="'Save the comment'"
      color="primary"
      :disabled="newComment === comment"
      variant="flat"
      @click="emit('change', newComment)"
      >Save</v-btn
    >
  </template>
  <v-container v-else><div v-html="markdown(comment)"></div></v-container>
</template>
<script setup lang="ts">
import { ref, watch } from "vue";
import { markdown } from "../markdown";

const props = defineProps<{
  comment: string;
  edit: boolean;
}>();
const emit = defineEmits<{
  (e: "change", comment: string): void;
  (e: "cancel-edit"): void;
}>();
const newComment = ref(props.comment);
watch(props, () => {
  newComment.value = props.comment;
});
</script>
